import React from 'react';
import { Navigation } from '../components/Navigation';
const TATTOO_IMAGES = ['https://cdn.magicpatterns.com/uploads/stE3d7TFdAXk5YN5axjfrB/1981267082.jpg', 'https://cdn.magicpatterns.com/uploads/c3DGhUYoozoyGK33awABCC/2275815293.jpg', 'https://cdn.magicpatterns.com/uploads/6VLZohqAQrx39YqaZSMiQn/2458969467.jpg', 'https://cdn.magicpatterns.com/uploads/5sCpYzSjk7rTPtkGQvTU7c/2495280365.jpg', 'https://cdn.magicpatterns.com/uploads/pGLe5fN6oAjxab2zpHb861/2517041999.jpg', 'https://cdn.magicpatterns.com/uploads/8kypErgq6RC6jkDHBTQjtZ/2648373749.jpg', 'https://cdn.magicpatterns.com/uploads/83rcrX9UsHaXTGA48RbKZe/2657750671.jpg'];
const GeometricPattern = () => <svg viewBox="0 0 100 100" className="w-full h-full opacity-10" data-id="element-136">
    <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-137" />
    <path d="M 10 50 L 90 50 M 50 10 L 50 90" stroke="currentColor" strokeWidth="2" data-id="element-138" />
  </svg>;
export function TattooPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-139">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border-2 border-[#ef3e23] shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-140">
        <Navigation activePath="/tattoo" data-id="element-141" />
        <main className="flex-1 px-4 md:px-16 py-8 space-y-16 md:space-y-32" data-id="element-142">
          {/* Hero Section */}
          <section className="relative flex flex-col justify-between pt-4 md:pt-8 pb-8 md:pb-12" data-id="element-143">
            <div className="max-w-6xl" data-id="element-144">
              <h1 className="text-[clamp(2.5rem,8vw,8rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-145">
                Tattoo <br data-id="element-146" />
                Concepts
                <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-147" />
              </h1>
              <div className="mt-6 max-w-sm text-base md:text-lg leading-[1.6] md:leading-[1.7] text-ink font-medium" data-id="element-148">
                Symbolic wing designs representing freedom, protection, and the
                duality of the narrative.
              </div>
            </div>
          </section>

          {/* Main Gallery */}
          <section className="space-y-8 md:space-y-12" data-id="element-149">
            <div className="bg-white rounded-[1rem] md:rounded-[1.5rem] p-6 md:p-12 border border-black/5 space-y-10" data-id="element-150">
              <div className="flex items-center gap-3" data-id="element-151">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-accent" data-id="element-152" />
                <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-153">
                  Visual Assets
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-154">
                {TATTOO_IMAGES.map((src, i) => <div key={i} className="group relative aspect-square rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm hover:shadow-md transition-all" data-id="element-155">
                    <img src={src} alt={`Tattoo Concept ${i + 1}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-156" />
                    <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border border-black/5" data-id="element-157">
                      Tattoo 0{i + 1}
                    </div>
                  </div>)}
              </div>
            </div>
          </section>

          {/* Style & Placement Section */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-158">
            <div className="bg-ink text-black rounded-[1.5rem] p-8 md:p-16 relative overflow-hidden" data-id="element-159">
              <div className="absolute top-0 right-0 w-48 h-48 opacity-20 -mr-12 -mt-12" data-id="element-160">
                <GeometricPattern data-id="element-161" />
              </div>
              <div className="relative z-10 space-y-6" data-id="element-162">
                <h3 className="text-3xl md:text-5xl font-semibold tracking-tight" data-id="element-163">
                  The Style
                </h3>
                <p className="text-black/60 text-lg leading-relaxed" data-id="element-164">
                  Fine-line detailing with high contrast. The wings should feel
                  ethereal yet grounded, utilizing stippling and hatching to
                  create depth without heavy solid blacks.
                </p>
                <div className="pt-6 flex flex-wrap gap-3" data-id="element-165">
                  {['Fine Line', 'Stippling', 'Monochrome', 'Detailed'].map(tag => <span key={tag} className="px-4 py-2 rounded-full border border-black/20 text-xs font-bold uppercase tracking-widest" data-id="element-166">
                        {tag}
                      </span>)}
                </div>
              </div>
            </div>

            <div className="bg-white rounded-[1.5rem] p-8 md:p-16 border border-black/5 flex flex-col justify-center space-y-8" data-id="element-167">
              <div className="space-y-4" data-id="element-168">
                <h3 className="text-3xl md:text-5xl font-semibold tracking-tight text-ink" data-id="element-169">
                  Placement
                </h3>
                <p className="text-ink/60 text-lg leading-relaxed" data-id="element-170">
                  Optimized for forearm or shoulder blade placement, allowing
                  the natural curves of the body to accentuate the flow of the
                  feathers.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-171">
                <div className="p-4 rounded-xl bg-[#d9e2e8]/30 border border-black/5" data-id="element-172">
                  <span className="block text-[10px] font-bold uppercase text-accent mb-1" data-id="element-173">
                    Primary
                  </span>
                  <span className="text-sm font-bold text-ink" data-id="element-174">
                    Inner Forearm
                  </span>
                </div>
                <div className="p-4 rounded-xl bg-[#d9e2e8]/30 border border-black/5" data-id="element-175">
                  <span className="block text-[10px] font-bold uppercase text-accent mb-1" data-id="element-176">
                    Secondary
                  </span>
                  <span className="text-sm font-bold text-ink" data-id="element-177">
                    Shoulder Blade
                  </span>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>;
}